import { useQuery } from '@tanstack/react-query';
import { documentService } from '@services/document';

export interface UseDocumentsParams {
  projectIds?: string[];
  taskIds?: string[];
  name?: string;
  category?: string;
  page?: number;
  limit?: number;
}

export const DOCUMENTS_QUERY_KEY = 'documents';

export const useDocuments = (params?: UseDocumentsParams) => {
  return useQuery({
    queryKey: [DOCUMENTS_QUERY_KEY, params],
    queryFn: () => documentService.getDocuments(params),
    enabled: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useDocuments;
